﻿/// <reference path="Definitions/jquery.d.ts" />

import * as $msg from './_msg'
import * as $modal from './_modal'
import * as $types from './_types'
import * as $resources from './_resources'
import * as $loading from './_loading'

var ajaxDefaults: $types.IAjaxOptions = {
    url: null,
    data: {},
    dataType: 'json',
    loadingText: $resources.text.loading,
    success: () => {},
    error: (_: JQueryXHR, textStatus: string) => {
        $loading.hide()
        $msg.showError(textStatus)
    },
    complete: () => {},
}

export function post(options: $types.IAjaxOptions): JQueryXHR {
    return ajax('POST', options)
}

export function get(options: $types.IAjaxOptions): JQueryXHR {
    return ajax('GET', options)
}

function ajax(type: string, options: $types.IAjaxOptions): JQueryXHR {
    options = <$types.IAjaxOptions>$.extend(true, {}, ajaxDefaults, options)

    $loading.show(options.loadingText)

    return $.ajax({
        type: type,
        url: options.url,
        data: options.data,
        success: (data: any, textStatus: string, xhr: JQueryXHR) => {
            $loading.hide()
            if (options.dataType == 'json' && !okResponseJson(data)) return
            if (options.dataType == 'html' && !okResponseHtml(data)) return
            options.success(data, textStatus, xhr)
        },
        dataType: options.dataType,
        error: (xhr: JQueryXHR, textStatus: string, errorThrown: string) => {
            $loading.hide()
            if ((textStatus || '').indexOf('abort') >= 0) return
            options.error(xhr, textStatus, errorThrown)
        },
        complete: (xhr: JQueryXHR, textStatus: string) => {
            options.complete(xhr, textStatus)
        },
    })
}

export function okResponseJson(response: any): boolean {
    if (!response || response === undefined) return true

    if (response.Fail && response.Fail === true) {
        showFailedResponseModal(response.FailReason, response.ReturnTo)
        return false
    }

    return true
}

export function okResponseHtml(response: string): boolean {
    if (!response || response === undefined) return true

    var responseArray = response.split('|')
    var responseFail = responseArray[0] == 'Fail'

    if (responseFail) {
        showFailedResponseModal(parseInt(responseArray[1]), responseArray[2])
        return false
    }

    return true
}

function showFailedResponseModal(failReason: number, returnTo: string): void {
    $modal.show(
        '<h4>Du har loggats ut</h4><p><a href="' +
            $resources.url.account.logIn +
            '?fail=' +
            failReason +
            '&returnTo=' +
            returnTo +
            '" class="empha">Klicka här</a> för att gå till inloggningssidan och logga in på nytt. Du kommer sedan skickas tillbaka till denna sida.</p>'
    )
}
